import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'
import { getIntroOnCircle } from '../helper.js'
import util from '@/utils/util.js'


export var getSingleArc = function(name = 'arc1', lineColor='rgba(0, 150, 255, 0.5)', arcColor='#0096FF'){
  return {
    type: 'arc',
    $dataIndex: 1,
    name: name,
    center: ['25%', '45%'],
    radius: [32, 39],
    title : {
        offsetCenter: [0, -54],
        textStyle: {
            color: '#A6A9AE',
            fontSize: 12
        }
    },
    circleStyle: {
        show: true,
        innerRadius: 32,
        outerRadius: 39,
        // 内圈
        innerStrokeColor: pageBg,
        innerFillColor: pageBg,
        // 外圈
        outerFillColor: '#25262A',
        outerStrokeColor: pageBg
    },
    itemStyle: {
        normal: {
            fill: lineColor,
            stroke:lineColor, 
            cornerRadius: 0
        },
        formatter: function (orginD, d) {
          let data = util.number.getUnitNumber(orginD.show, 0)
          let info = getIntroOnCircle(d)
          let num;
          if(Math.abs(orginD.show)<8){
            num = orginD.show.toFixed(2)
          }else{
            num = parseFloat(data).toFixed(0)
          }
          let unit = data.replace(/[0-9]/g, '').replace(/[-]/g, '')
          return '{a|'+ num +'}{b|'+ unit +'}\n{a|'+ info +'}';
        },
        textStyle: {
            position: 'center',
            color: '#A6A9AE',
            textLineHeight: 19,
            fontFamily: 'DIN-Regular',
            rich: {
              a: {
                  fill: '#fff'
              },
              b: {
                  fill: '#A6A9AE'
              }
          }
        }
    },
    startArc: {
        show: true,
        angleCross: 3, // {number} 度 360度为分母
        normal: {
            fill: arcColor,
            stroke: arcColor,
            cornerRadius: 0
        }
    },
    endArc: {
        show: true,
        angleCross: 3, // {number} 度 360度为分母
        normal: {
            fill: arcColor,
            stroke: arcColor,
            cornerRadius: 0
        }
    }
}
}

export var getLine1 = function(name='销量 1', lineColor, dataKey='x', axisIndex=[0,1], zplus=0){
  let z = 3+zplus;
  return { 
    type: 'line',
    $dataIndex: 0,
    $axisIndex: axisIndex,
    dataKey: dataKey,
    name: name,
    z: z,
    line: {
      show: true,
      style: {
        normal: {
          stroke: lineColor || blue,
          lineWidth: 2
        }
      }
    }
  }
}

// export var getLine2 = function(name, lineColor, dataKey){
//   var line = getLine1(name, lineColor, dataKey);
//   line.$axisIndex = [0, 2];
//   line.dataKey = 'y';
//   line.name = name || '销量 2';
//   line.line.style.normal.stroke = lineColor || red;
//   return line;
// }

export var getArea1 = function({name='销量 1', lineColor, dataKey='x'}){

  var area1 = getLine1(name, lineColor, dataKey);
  area1.area = {
    // 区域从底部开始画
    normal: {
      show: true, // {boolean} 是否显示面积
      snapToBottom: false, // {boolean} 吸附到底部
      // {Object} 面积样式
      style: {
        fill: {
          y2: 1,
          x2: 0,
          colorStops: [
          {
            offset: 0,
            color: area1.line.style.normal.stroke
          },
          {
            offset: 1,
            color: pageBg
          }
          ]
        },
        opacity: 0.1
      }
    }
  }
  return area1
}

// export var getArea2 = function({name='销量 2', lineColor, dataKey='x'}){
//   var line2 = getArea1({name, lineColor, dataKey});
//   line2.dataKey = 'y';
//   line2.name = '销量 2';
//   line2.line.style.normal.stroke = red;
//   line2.area.normal.style.fill.colorStops = [
//     { offset: 0, color: red },
//     { offset: 1, color: pageBg }
//   ]
//   return line2;
// }

// export var getArea3 = function(){
//   var line3 = getArea1();
//   line3.dataKey = 'z';
//   line3.name = '销量 3';
//   line3.line.style.normal.stroke = yellow;
//   line3.area.normal.style.fill.colorStops = [
//     { offset: 0, color: yellow },
//     { offset: 1, color: pageBg }
//   ]
//   return line3;
// }

export var getBar1 = function({name='销量 2', lineColor, dataKey='y'}){
  return {
    type: 'bar',
    $dataIndex: 0,
    $axisIndex: [0, 2],
    dataKey: dataKey,
    name: name,
    itemStyle: {
      normal: {
        fill: lineColor || red
      }
    }
  }
}